import { render, staticRenderFns } from "./ThePictureEditor.vue?vue&type=template&id=8c230b5a&scoped=true&"
import script from "./ThePictureEditor.vue?vue&type=script&lang=js&"
export * from "./ThePictureEditor.vue?vue&type=script&lang=js&"
import style0 from "./ThePictureEditor.vue?vue&type=style&index=0&id=8c230b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c230b5a",
  null
  
)

export default component.exports